/**
 * Formats a compact 8-digit date string into German dot-notation.
 * e.g. "22111989" → "22.11.1989"
 *
 * @param {string} value
 * @returns {string} formatted date string, or the original value if not 8 digits
 */
export function formatCompactDate(value) {
  if (/^\d{8}$/.test(value)) {
    return `${value.substring(0, 2)}.${value.substring(2, 4)}.${value.substring(4, 8)}`;
  }
  return value;
}
